var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.table.content.pagination.pages >= 1)?_c('v-layout',{attrs:{"mt-5":"","align-center":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{class:{
                      'row': _vm.$vuetify.breakpoint.mdAndUp,
                      'column': _vm.$vuetify.breakpoint.mdAndDown,
                      'justify-center': _vm.$vuetify.breakpoint.mdAndDown
                  },attrs:{"wrap":"","justify-space-between":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md7":"","lg6":""}},[(_vm.table.content.pagination.pages > 1)?_c('v-pagination',{attrs:{"length":_vm.pages,"total-visible":_vm.$vuetify.breakpoint.xs ? 4 : 6,"prev-icon":"arrow_back_ios","next-icon":"arrow_forward_ios"},model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}}):_vm._e()],1),_c('v-flex',{class:{'mt-4': _vm.$vuetify.breakpoint.mdAndDown},attrs:{"xs8":"","sm8":"","md7":"","lg6":""}},[_c('v-select',{staticClass:"input",attrs:{"items":_vm.$vuetify.breakpoint.mdAndUp ?
                        [
                            {
                                text: _vm.$t('Показывать по 10'),
                                value: 'Показывать по 10',
                            },
                            {
                                text: _vm.$t('Показывать по 25'),
                                value: 'Показывать по 25',
                            },
                            {
                                text: _vm.$t('Показывать по 50'),
                                value: 'Показывать по 50',
                            },
                            {
                                text: _vm.$t('Показывать по 100'),
                                value: 'Показывать по 100',
                            },
                        ]
                        :
                        [
                            {
                                text: _vm.$t('Показывать по 10'),
                                value: 'Показывать по 10',
                            },
                            {
                                text: _vm.$t('Показывать по 25'),
                                value: 'Показывать по 25',
                            },
                            {
                                text: _vm.$t('Показывать по 50'),
                                value: 'Показывать по 50',
                            },
                    ],"solo":"","append-icon":"","label":_vm.$t('Показывать по 10')},on:{"change":function($event){return _vm.show_number($event)}},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-icon',{attrs:{"aria-hidden":"true","translate":"no"}},[_vm._v("\n                      expand_more\n                    ")])]},proxy:true}],null,false,2520844655)})],1)],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }